module.exports = __webpack_public_path__ + "static/media/Wheat-Icon.06c5be90.svg";